import { render, staticRenderFns } from "./blacklist-details.vue?vue&type=template&id=4ab228bc"
import script from "./blacklist-details.vue?vue&type=script&lang=js"
export * from "./blacklist-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports